import { render, staticRenderFns } from "./chooseItemDialog.vue?vue&type=template&id=66b24558&scoped=true"
import script from "./chooseItemDialog.vue?vue&type=script&lang=js"
export * from "./chooseItemDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseItemDialog.vue?vue&type=style&index=0&id=66b24558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b24558",
  null
  
)

export default component.exports